import { IAbcComponent, StylingMode } from '../abcComponent.model';

export interface ITextArea extends IAbcComponent {
  placeholder?: string;
  value?: any;
  matAutosizeMinRows?: number;
  setTextAreaStyle(style?: TextAreaStyle);
}

export class TextAreaStyle {
  height: string | number;
  width: string | number;
  disabled?: boolean;
  minHeight?: number;
  maxHeight?: number;
  autoResizeEnabled?: boolean;
  activeStateEnabled?: boolean;
  focusStateEnabled?: boolean;
  hoverStateEnabled?: boolean;
  name?: string;
  readOnly?: boolean;
  matRequired?: boolean;
  rtlEnabled?: boolean;
  spellcheck?: boolean;
  stylingMode?: StylingMode;
  validationMessageMode?: ValidationMessageMode;
  validationStatus?: ValidationStatus;
  visible?: boolean;
  class?: string;
}

export enum TextAreaStylingMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}

export enum ValidationMessageMode {
  Auto = 'auto',
  Always = 'always',
}

export enum ValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Pending = 'pending',
}
